export enum Screens {
  Home = 'Home',
  Search = 'Search',
  Cart = 'Cart',
  Wishlist = 'Wishlist',
  Profile = 'Profile',
}

export enum Routes {
  SignIn = '/',
  OrderHistory = '/profile/orders',
  OrderHistoryEmpty = '/profile/orders-empty',
  EditProfile = '/profile/edit',
  VerifyYourEmail = '/verify-your-email',
  MyPromocodes = '/profile/promocodes',
  NewPassword = '/new-password',
  Filter = '/filter',
  SignUp = '/sign-up',
  SignUpAccountCreated = '/sign-up-account-created',
  ForgotPassword = '/forgot-password',
  OrderSuccessful = '/order-successful',
  Checkout = '/checkout',
  ForgotPasswordSentEmail = '/forgot-password-sent-email',
  Shop = '/shop',
  Reviews = '/reviews',
  Description = '/description',
  LeaveAReviews = '/leave-a-reviews',
  Product = '/product/:id',
  MyPromocodesEmpty = '/profile/promocodes-empty',
  TabNavigator = '/tab-navigator',
  Verification = '/verification',
  ConfirmationCode = '/confirmation-code',
  SendEmailOtp = '/send-email-otp',
  VerifyEmail = '/verify-email',
  SendPhoneOtp = '/send-phone-otp',
  VerifyPhone = '/verify-phone',
  EmailVerified = '/email-verified',
  PhoneVerified = '/phone-verified',
  ShippingAPaymentInfo = '/shipping-a-payment-info',
  OrderFailed = '/order-failed',
  TrackYourOrder = '/track-your-order',
  FAQ = '/faq',
  MyAddress = '/my-address',
  CheckoutPaymentMethod = '/checkout-payment-method',
  CheckoutShippingDetails = '/checkout-shipping-details',
  PaymentMethod = '/payment-method',
  AddANewAddress = '/add-a-new-address',
  AddANewCard = '/add-a-new-card',
  VerifyYourPhoneNumber = '/verify-your-phone-number',
}
